// extracted by mini-css-extract-plugin
export default {"container":"Artisans_container_PrNfK","title":"Artisans_title_WdgmI","text":"Artisans_text_n0cpr","artisan":"Artisans_artisan_HQTOm"};